var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Law(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 63H8a4 4 0 014-4h34a4 4 0 014 4zm16.18-6.93L55 44.89a2.998 2.998 0 00-2.28-.89L39 30.26l4-4-.08-.08L32.5 15.77l-.09-.09-10.86 10.86.22.22 10.34 10.35 4-4L49.9 46.86a3 3 0 00.86 2.28l11.18 11.17a3 3 0 005.117-2.12 3 3 0 00-.877-2.12zM45.29 23.93l5.37-2.31L37.17 8.13l-2.4 5.2-.15.32L45 24l.29-.07zM30 39.28v-.05L19.65 28.88l-.76.32L14 31.31l13.49 13.48L30 39.28z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Law.5689a422.svg";
export { SvgK1Law as ReactComponent };